// To add a new output style:
//   1. Add an entry here
//   2. For each ComputedCompetitionClass, define the style output

export enum RenderStyles {
    standard_txt,
    standard_html,
    cascade_wordpresshtml,
    cascade_wifihtml,
    cascade_winterawards
}